export default __webpack_public_path__ + "static/20-inch-disk-view-insidex150-4d83e2b62fe19b1c970bc5a52318d102.png";